<template>
	<div>
		<div class="fs-desc">
			Regisztrált már az Eurorisk oldalán? Gyorsítsa fel a kalkulációt. Bejelentkezés után a már megadott adatokat
			betöltjük a rendszerbe. Nem csak a kalkulációt tudjuk gyorsítani, de az előző kalkulációját is be tudjuk
			tölteni, illetve le tudja tölteni PDF-ben.
		</div>

		<ValidationObserver ref="form" slim>
			<div :class="minimal ? 'login-form' : 'form mw-515px m-auto mt-20px'">
				<ValidationProvider
					name="E-mail cím"
					rules="required|email"
					v-slot="{ errors, classes }"
					slim
					mode="eager"
				>
					<div>
						<div :class="classes">
							<input
								type="text"
								class="field"
								placeholder="E-mail cím"
								v-model="email"
								inputmode="email"
								data-hj-allow
							/>
						</div>
						<span class="error_message error_message--broke">{{ errors[0] }}</span>
					</div>
				</ValidationProvider>
				<ValidationProvider name="Jelszó" rules="required" v-slot="{ errors, classes }" slim mode="eager">
					<div>
						<div :class="classes">
							<input
								type="password"
								class="field"
								placeholder="Jelszó"
								v-model="password"
								inputmode="text"
								data-hj-allow
							/>
						</div>
						<span class="error_message error_message--broke">{{ errors[0] }}</span>
					</div>
				</ValidationProvider>
				<div v-if="!minimal" class="d-flex mt-23px">
					<a href="javascript:void(0)" class="mb-30px m-auto d-table" @click="showPopup('ForgottenPassword')">
						Elfelejtettem a jelszavam!
					</a>
					<a
						href="javascript:void(0)"
						class="mb-30px m-auto d-table"
						@click="showPopup(registrationComponent)"
					>
						{{ registrationText }}
					</a>
				</div>

				<button
					type="button"
					:class="minimal ? 'btn-transparent login-form_btn' : 'btn btn-blue m-auto mt-12px'"
					@click="handleLogin"
				>
					<span class="user-icon grayscale-img" v-if="minimal"></span>
					Bejelentkezés
				</button>
			</div>
		</ValidationObserver>
	</div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';

export default {
	props: {
		minimal: {
			type: Boolean,
			default: false,
		},
		registrationComponent: {
			type: String,
			default: 'Registration',
		},
		registrationText: {
			type: String,
			default: 'Regisztráció',
		},
	},
	data() {
		return {
			email: null,
			password: null,
		};
	},
	methods: {
		...mapActions('auth', ['login']),
		...mapActions(['fetchRealEstates']),
		...mapMutations(['showPopup']),
		async handleLogin() {
			this.$refs.form.validate().then(async success => {
				if (success) {
					const response = await this.login({ email: this.email, password: this.password });

					if (response !== undefined) {
						this.$refs.form.setErrors(response);
					} else {
						await this.fetchRealEstates();
						this.$emit('success');
						this.showPopup(null);
					}
				}
			});
		},
	},
};
</script>
